module.exports = __webpack_public_path__ + "static/img/landing_button1.50c6eff.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/landing_button1.gif
// module id = l4Yi
// module chunks = 0